"use client";

import React from "react";
import {useTranslation} from "react-i18next";
import Input from "@/components/library/Input";
import {
   type TwilioSmsFormErrors,
   type TwilioSmsFormValues,
} from "@/utils/integrations/smsValidation";

interface TwilioSmsFieldsProps {
   values: TwilioSmsFormValues;
   errors: TwilioSmsFormErrors;
   /** True when editing the currently stored provider — a blank auth token keeps the stored one. */
   secretOptional: boolean;
   onChange: (field: keyof TwilioSmsFormValues) => (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export default function TwilioSmsFields({values, errors, secretOptional, onChange}: TwilioSmsFieldsProps) {
   const {t} = useTranslation("partners");
   const secretHelper = secretOptional ? t("smsIntegration.form.secretKeepHelper") : undefined;

   return (
      <>
         <Input
            id="sms-phone-number"
            type="text"
            name="phoneNumber"
            label={t("smsIntegration.form.phoneNumber")}
            placeholder={t("smsIntegration.form.phoneNumberPlaceholder")}
            value={values.phoneNumber}
            onChange={onChange("phoneNumber")}
            error={!!errors.phoneNumber}
            helperText={errors.phoneNumber}
            data-testid="sms-phone-number"
         />
         <Input
            id="sms-account-sid"
            type="text"
            name="accountSid"
            label={t("smsIntegration.form.accountSid")}
            value={values.accountSid}
            onChange={onChange("accountSid")}
            error={!!errors.accountSid}
            helperText={errors.accountSid}
            data-testid="sms-account-sid"
         />
         <Input
            id="sms-auth-token"
            type="passwordShow"
            name="authToken"
            label={t("smsIntegration.form.authToken")}
            value={values.authToken}
            onChange={onChange("authToken")}
            error={!!errors.authToken}
            helperText={errors.authToken ?? secretHelper}
            data-testid="sms-auth-token"
         />
         <Input
            id="sms-messaging-service-sid"
            type="text"
            name="messagingServiceSid"
            label={t("smsIntegration.form.messagingServiceSid")}
            value={values.messagingServiceSid}
            onChange={onChange("messagingServiceSid")}
            error={!!errors.messagingServiceSid}
            helperText={errors.messagingServiceSid}
            data-testid="sms-messaging-service-sid"
         />
      </>
   );
}
